import { render } from "./AssignmentControl.vue?vue&type=template&id=9345c74a"
import script from "./AssignmentControl.vue?vue&type=script&lang=js"
export * from "./AssignmentControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__